<div class="mx-6 my-6">
    <router-outlet></router-outlet>
</div>
